import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { RecursoCampanhaSelectModule } from '../../select';
import { RecursoCampanhaFormComponent } from './recurso-campanha-form.component';

@NgModule({
    imports: [
        SharedModule,
        RecursoCampanhaSelectModule
    ],
    declarations: [
        RecursoCampanhaFormComponent
    ],
    exports: [
        RecursoCampanhaFormComponent
    ]
})
export class RecursoCampanhaFormModule { }
